import { ChangeEvent, FunctionComponent, useEffect, useRef, useState } from "react";
import { Autocomplete, CircularProgress, createFilterOptions, Dialog, TextField } from "@mui/material";
import images from "../../assets/images";
import { useDropzone } from "react-dropzone";
import { Card, CardCover } from "@mui/joy";
import { useLazyQuery, useMutation } from "@apollo/client";
import "./FileUpload.scss";
import ToasterWithMessage from "../toaster";
import axios from "axios";
import moment from "moment";
import { STUDENT_ROLE, TEACHER_ROLE, VIRTUAL_S3_PATH, messages, patterns } from "../../utils/constants";
import { CHECK_UNIQUE_NAME_EXIST_IN_WORKSHOP, GET_PRESIGNED_URL } from "./api/FileUploadQuery";
import { useAppSelector } from "../../redux/app/hooks";
import { VIEW_ALL_LIBRARY_IMAGES } from "../../pages/ImageMaterial/api/ImageMaterialQuery";
import { VIEW_ALL_EBOOK_MATERIAL } from "../../pages/TeacherTeachingMaterial/api/TeacherTeachingMaterialQuery";
import { useNavigate } from "react-router-dom";
import { ADD_CATEGORY, GET_ALL_SYNDICATED_VIDEOS, GET_CATEGORY } from "../../pages/SyndicatedVideos/api/SyndicatedVideosQuery";
import React from "react";
import { isPlatform } from "@ionic/react";
import { getScreenDimensions } from "../../utils/helper";

export type FileTypes = {
  all: 'all';
  pdf: 'pdf';
  image: 'image';
  video: 'video';
  audio: 'audio';
  assignment: 'assignment';
  profile: 'profile';
  questionsBank: 'questionsBank';
  teachingMaterials: 'teachingMaterials';
};

export type FileUploadType = {
  type: FileTypes[keyof FileTypes];
  setUrl: (val: string) => void;
  setCoverImageUrl?: (val: string) => void;
  open: boolean;
  setOpen: any;
  setIsUploadOpen?:any;
  setFileData?: any;
  folderName: string;
  setFilename?: any;
  name?: string;
  setWorkshopDescription?: (val: string) => void;
  setPodcastDescription?: (val: string) => void;
  setGuideAuthorName?: (val: string) => void;
  setVideoCategoryData?: (val:categoryType|null|undefined) => void;
  setUploadProgress?: React.Dispatch<React.SetStateAction<number>>;
  setUploadFailed?: React.Dispatch<React.SetStateAction<boolean>>;
  setuploaded?:React.Dispatch<React.SetStateAction<boolean>>;
  setUploadFileName?:React.Dispatch<React.SetStateAction<string>>;
};

export type categoryType = {
  inputValue?: string;
  label:string;
  id?:string;
}

const FileUpload: FunctionComponent<FileUploadType> = ({ type, name, setPodcastDescription,setGuideAuthorName, setUrl, setCoverImageUrl, open, setOpen, setFileData, folderName, setFilename, setVideoCategoryData,setUploadProgress, setUploadFailed, setuploaded, setUploadFileName, setIsUploadOpen, setWorkshopDescription }) => {
  const { closeIcon, cloudGif, podcast, pdfImg, CoverPlusImage, csvImg, docsImg, excelPreview, powerpoint, epub } = images;
  // const [uploaded, setuploaded] = useState(false);
  const descriptionRef = useRef<HTMLTextAreaElement>(null); // Add ref for textarea
  const [coverFileName, setCoverFileName] = useState<string>('');
  const [coverImageFile, setCoverImageFile] = useState<File | null>(null);
  const [descriptionValue, setDescriptionValue] = useState<string>('');
  const [fileName, setFileName] = useState<string>("");
  const [authorNameValue, setAuthorNameValue] = useState<string>('');
  const [videoCategoryValue, setVideoCategoryValue] = useState<categoryType|null>();
  const [file, setFile] = useState<File | null>(null);
  const [fileType, setFileType] = useState<string>();
  const [filePreview, setFilePreview] = useState<string>();
  const role = useAppSelector((state) => state.auth.role);
  const { error } = ToasterWithMessage();
  const [fileNameError, setFileNameError] = useState<string | null>(null);
  const [authorNameError, setAuthorNameError] = useState<string | null>(null);
  const [videoCategoryError, setVideoCategoryError] = useState<string | null>(null);
  const [descriptionError, setDescriptionError] = useState<string | null>(null);
  const [accepted, setAccepted] = useState<object>({});
  const [categories, setCategories] = useState<categoryType[]>([]);
  const [inputValue, setInputValue] = useState<string>('');
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);
  const bucketname = process.env.REACT_APP_MEDIA_BUCKET_NAME;
  const region = process.env.REACT_APP_REGION;
  const selectedClassId = useAppSelector((state) => state?.auth?.selectedClassRoomId);
  const selectedLibraryId = localStorage.getItem('selectedLId');
  const selectedSubjectId = localStorage.getItem('selectedSId');
  const navigate = useNavigate();
  const filter = createFilterOptions<categoryType>();

  const descriptionAllowedTypes = ['PodcastMaterial', 'workshopVideo'];

    // to get presignedURL
  const [getPreSignedUrl] = useLazyQuery(GET_PRESIGNED_URL, {
    fetchPolicy: "network-only",
    onCompleted: (data) => { },
    onError: (err) => {
      // error("Something went wrong!")
    }
  });

  //API to check the unique name in image material
  const [getAllImagePodcastMaterial] = useLazyQuery(VIEW_ALL_LIBRARY_IMAGES, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => { },
    onError: (err) => {
      error(err?.message);
      if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
        setTimeout(() => {
          if (name === "ImageMaterial") {
            if(role === STUDENT_ROLE){
              navigate('/student-classroom/images', { state: { title: 'Images' } });
            }else{
               navigate('/teacher-classroom/images', { state: { title: 'Images' } });
            }
          } else if (name === 'PodcastMaterial') {
            if(role === STUDENT_ROLE){
              navigate('/student-classroom/podcast', { state: { title: 'Podcast' } });
            }else{
              navigate('/teacher-classroom/podcast', { state: { title: 'Podcast' } });
            }
          }
        }, 2000);
      }
    }
  });
  
  //API to check the unique name in e-books
  const [getAllTeachingMaterial] = useLazyQuery(VIEW_ALL_EBOOK_MATERIAL, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => { },
    onError: (err) => {
      error(err?.message);
      if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
        setTimeout(() => {
          if (role === STUDENT_ROLE) {
            navigate('/student-classroom/ebooks', { state: { title: 'E-Books' } });
          } else {
            navigate('/teacher-classroom/ebooks', { state: { title: 'E-Books' } });
          }
        }, 2000);
      }
    }
  });


  //API to check the unique name in e-books
  const [checkUniqueNameExistInWorkshop] = useLazyQuery(CHECK_UNIQUE_NAME_EXIST_IN_WORKSHOP, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => { },
    onError: (err) => {
      error(err?.message);
      console.log("error mesage", err?.message);
    }
  });

//   const [checkUniqueNameInAssignment] = useLazyQuery(GET_ASSIGNMENTS, {
//     fetchPolicy: 'network-only',
//     onCompleted: (data) => {},
//     onError: (err) => {
//         error(err?.message);
//         if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
//             setTimeout(() => {
//                 if (role === STUDENT_ROLE) {
//                     navigate('/student-classroom/assignments');
//                 } else {
//                     navigate('/teacher-classroom/assignments');
//                 }
//             }, 2000);
//         }
//     }
// });

// const [checkUniqueNameInSubmitAssignment] = useLazyQuery(GET_ALL_SUBMITTED_ASSIGNMENTS, {
//   fetchPolicy: 'network-only',
//   onCompleted: (data) => {},
//   onError: (err) => {
//       error(err?.message);
//       if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
//           setTimeout(() => {
//               if (role === STUDENT_ROLE) {
//                   navigate('/student-classroom/assignments');
//               } else {
//                   navigate('/teacher-classroom/assignments');
//               }
//           }, 2000);
//       }
//   }
// });

  const [getAllSyndicatedVideos] = useLazyQuery(GET_ALL_SYNDICATED_VIDEOS, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {},
    onError: (err) => {
        error(err?.message);
        if (err?.message === "Subject not found for teacher" || err?.message === "Subject not found") {
            setTimeout(() => {
                if (role === STUDENT_ROLE) {
                    navigate('/student-classroom/videos', { state: { title: 'Syndicated Videos' } });
                } else {
                    navigate('/teacher-classroom/videos', { state: { title: 'Syndicated Videos' } });
                }
            }, 2000);
        }
    }
});

//To get video category
const [getCategory,{loading:getCategoryLoading}] = useLazyQuery(GET_CATEGORY,{
  fetchPolicy: 'network-only',
  onCompleted:(data)=>{
    const fetchedCategories = data.allSubjectCategories.nodes.map((videoData: any) => ({
      label: videoData.scNameCapitalized,
      id: videoData.scId
    }));
    setCategories(fetchedCategories);
  },
  onError:(err)=>{
     error(err?.message);
  }
});

 //To add video category
 const [addCategory,{loading:addCategoryLoading}] = useMutation(ADD_CATEGORY,{
  fetchPolicy: 'network-only',
  onCompleted:(data) => {
    if(data?.addSubjectCategory){
      setVideoCategoryValue((prevValue) => {
        if (prevValue) {
          return {
            ...prevValue,
            id: data.addSubjectCategory,
            label: prevValue.label // Keep existing label or modify as needed
          };
        } else {
          return {
            id: data.addSubjectCategory,
            label: '' // Default label if prevValue is null or undefined
          };
        }});
      getCategory({
        variables:{
          sjId:selectedSubjectId
        }
      });
    }
  },
   onError:(err)=>{
      error(err?.message);
   }
 });

useEffect(()=>{
if(name === "Syndicated Videos"){
  getCategory({
    variables:{
      sjId:selectedSubjectId
    }
  });
}
},[name,open]);

  const sxStyles = {
    '.MuiOutlinedInput-root': {
      paddingRight: "45px !important",
      fontWeight: 500,
      fontFamily: 'var(--font-inter)',
      fontSize: 'var(--font-size-xs)',
      backgroundColor: 'var(--color-whitesmoke-400)',
      borderRadius: 'var(--br-3xs)',
      height: 40,
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%'
    },
    '.MuiAutocomplete-hasPopupIcon .MuiOutlinedInput-root, .MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root': {
      paddingRight: 0,  // Set padding-right to 0 for specified classes
    },
    '.MuiAutocomplete-hasPopupIcon .MuiAutocomplete-inputRoot, .MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot': {
      paddingRight: 0,  // Set padding-right to 0 for specified classes
    },
    '.MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '.MuiFormLabel-root': {
      fontWeight: 500,
      fontFamily: 'var(--font-inter)',
      fontSize: 'var(--font-size-xs)',
      display: 'none'
    },
    '.MuiInputLabel-root': {
      fontWeight: 500,
      fontFamily: 'var(--font-inter)',
      fontSize: 'var(--font-size-xs)',
      display: 'none'
    },
    width: '100%',
    Padding: '0px',
    ".MuiAutocomplete-popupIndicator": {
      display: "none",
    },
  };
 // select the cover image
 const { getRootProps: coverImageRootProps, getInputProps: coverImageInputProps } = useDropzone({
  accept: {
    'image/jpeg': [],
    'image/png': [],
    'image/svg+xml': [],
    'image/jpg': []
  },
  noDrag: true, // Disable drag-and-drop
  multiple: false,
  onDrop: (acceptedFiles) => {
    if(acceptedFiles?.length !== 0){
      const maxAllowedSize = 5 * 1024 * 1024;
      if(acceptedFiles[0].size <= maxAllowedSize){
            setCoverFileName(acceptedFiles[0]?.name.replace(/\s+|\(|\)/g, ''));
            setCoverImageFile(acceptedFiles[0]);
      }else {
        error("File size must be less than or equal to 5 MB");
      }
    }
  },
  onDropRejected(fileRejections, event) {
    if (fileRejections?.[0]?.errors?.[0]?.code === 'file-invalid-type') {
      error(`Please select either jpg, jpeg, png or svg image`);
    }
  },
});

  // Drag and drop the image
  const { getRootProps, getInputProps } = useDropzone({
    accept: { ...accepted },
    multiple: false,
    onDrop: (acceptedFiles) => {
      if (acceptedFiles?.length !== 0) {
        let maxAllowedSize = 0;
        if(type === 'profile' || type === 'image'){
          maxAllowedSize = 5 * 1024 * 1024; // 5MB
        }else if(type === 'pdf' || type === 'questionsBank' || type === "assignment" || type === "teachingMaterials"){
          maxAllowedSize = 25 * 1024 * 1024; // 25MB
        }else if(type === 'audio'){
          maxAllowedSize = 100 * 1024 * 1024; // 100MB
        }else if(type === 'video'){
          maxAllowedSize = 500 * 1024 * 1024; // 500MB
        }
        if (acceptedFiles[0].size <= maxAllowedSize) {
          setFile(acceptedFiles[0]);
          setFileNameError('');
          const fileNameWithoutExtension = acceptedFiles[0]?.name.split('.').slice(0, -1).join('.');
          setFileName(fileNameWithoutExtension);
          if(setUploadFileName){
            setUploadFileName(fileNameWithoutExtension);
          }
          const selectedFileType = acceptedFiles[0]?.type.split("/")?.[0];
          setFileType(selectedFileType);
          if (selectedFileType === "audio") {
            setFilePreview(podcast);
          }
          else if (acceptedFiles[0]?.type === "application/pdf") {
            setFilePreview(pdfImg);
          }
          else if (selectedFileType === "text" || 
            acceptedFiles[0]?.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
            acceptedFiles[0]?.type === "application/vnd.ms-excel" || 
            acceptedFiles[0]?.type === "application/vnd.ms-powerpoint" || 
            acceptedFiles[0]?.type === "application/vnd.openxmlformats-officedocument.presentationml.presentation"
          ) {
            setFilePreview(selectedFileType === "text" ? csvImg : (acceptedFiles[0]?.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || acceptedFiles[0]?.type === "application/vnd.ms-excel") ? excelPreview : powerpoint);
          }
          else if (acceptedFiles[0]?.type === "application/msword" || acceptedFiles[0]?.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
            setFilePreview(docsImg);
          }
          else if (acceptedFiles[0]?.type === "application/epub+zip") {
            setFilePreview(epub);
          }
          else {
            setFilePreview(URL.createObjectURL(acceptedFiles[0]));
          }
        }
        else {
          if(type === 'profile' || type === 'image'){
            error("File size must be less than or equal to 5 MB");
          }else if(type === 'pdf' || type === 'questionsBank' || type === 'assignment' || type === "teachingMaterials"){
          error("File size must be less than or equal to 25 MB");
          }else if(type === 'audio'){
          error("File size must be less than or equal to 100 MB");
          }else if(type === 'video'){
          error("File size must be less than or equal to 500 MB");
          }
        }
      }
    },
    onDropRejected(fileRejections, event) {
      if (type === 'profile' || type === "image") {
        if (fileRejections?.[0]?.errors?.[0]?.code === 'file-invalid-type') {
          error(`Please select either jpg, jpeg, png or svg image`);
        }
      }else if(type === 'video'){
           error('Please select MP4 file')
       } else if(type === 'questionsBank'){
          error('Please select CSV file')
      }else if(type === 'assignment'){
           error('Please select pdf, csv, ppt or word file')
      }else if(type === 'teachingMaterials'){
            error('Please select pdf, csv, ppt, epub or word file')
      }else {
        error(`Please select ${type} file`);
      }
    },
  });

  useEffect(() => {
    // set accepted file formats
    if (type === "all") {
      setAccepted({
        "video/*": [],
        'image/jpeg': [],
        'image/png': [],
        'image/svg+xml': [],
        'image/jpg': [],
        "audio/mpeg": [],
        "audio/x-wav": [],
        "audio/ogg": [],
        "application/pdf": []
      });
    } else if (type === "image" || type === "profile") {
      setAccepted({
        'image/jpeg': [],
        'image/png': [],
        'image/svg+xml': [],
        'image/jpg': []
      });
    } else if (type === "pdf" ) {
      setAccepted({ "application/pdf": [] });
    } else if (type === "video") {
      setAccepted({ "video/mp4": [] });
    } else if(type === 'audio') {
      setAccepted({ 
        "audio/mpeg": [],
        "audio/wav": [],
        "audio/ogg": [],
      });
    } else if(type === 'questionsBank'){
      isPlatform('android') ? 
      setAccepted({
      }) : 
      setAccepted({
        "text/csv": []
      }) 
    }
    else if (type === "assignment") {
      setAccepted({
        "text/csv": [],
        "application/pdf": [],
        "application/msword": [],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
        "application/vnd.ms-excel": [],
        "application/vnd.ms-powerpoint": [],
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": []
      })
    }
    else if (type === "teachingMaterials") {
      setAccepted({
        "text/csv": [],
        "application/pdf": [],
        "application/msword": [],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
        "application/vnd.ms-excel": [],
        "application/vnd.ms-powerpoint": [],
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": [],
        "application/epub+zip": []
      })
    }
  }, [type]);

  //Upload the cover image
  const handleUploadCoverImage = async () => {
    if(coverFileName && coverImageFile){
      try{
        const newFileName = `${VIRTUAL_S3_PATH}${folderName}/${moment().unix()}-${coverImageFile?.name}`;
        const { data } = await getPreSignedUrl({
          variables: {
            input: {
              key: newFileName
            }
          }
        });
        const { preSignedUrl } = data.getUploadPresignedUrl;
        await axios.put(preSignedUrl, coverImageFile, {
          headers: {
            "Content-Type": coverImageFile.type
          }
        });
  
        const fileUrl = preSignedUrl.split('?')[0];
        const url = fileUrl.split(`https://${bucketname}.s3.${region}.amazonaws.com/`)[1];
        if(setCoverImageUrl){
          setCoverImageUrl(url);
        }
      }catch(err:any){
          console.log("error while uploading cover image", err?.message);
      }
    }
  }


  // Uploding the submitted file
  const handleSubmit = async () => {
    setHasSubmitted(true);
    if (!file) {
      error("Please select the file");
      return;
    }
    
    if(type === 'video' && name !== "Syndicated Videos"){
      const fileTitleError = validateFileName(fileName,'FileName');
      const descriptionValidationError = validateDescription(descriptionValue.trim());
      if(fileTitleError || descriptionValidationError){
        if(fileTitleError){
          setFileNameError(fileTitleError);
        }
        if(descriptionValidationError){
          setDescriptionError(descriptionValidationError);
        }
        return;
      }
    }

    if (type === "audio") {
      const validationError = validateFileName(fileName,"FileName");
      const descValidationError: any = validateDescription(descriptionValue.trim());
      if(validationError || descValidationError){
        if(validationError){
          setFileNameError(validationError);
        }
        if(descValidationError){
          setDescriptionError(descValidationError);
        }
        return;
      }
    };

  // Handle video category validation for "Syndicated Videos"
  if (name === "Syndicated Videos") {
    setVideoCategoryError('');
    if (!videoCategoryValue) {
      setVideoCategoryError('Video category is required');
      return;
    }
    const categoryLabel = videoCategoryValue.inputValue || videoCategoryValue.label;
    const validationError = validateVideoCategory(categoryLabel);

    if (validationError) {
      setVideoCategoryError(validationError);
      return;
    }

    if (videoCategoryValue.id === undefined) {
      // If category ID is not yet available, add the category before proceeding
      try {
        const response = await addCategory({
          variables: { category: categoryLabel?.trim(), sjId: selectedSubjectId }
        });

        const addedCategoryId = response.data.addSubjectCategory;
        setVideoCategoryValue({ id: addedCategoryId, label: categoryLabel });
      } catch (err:any) {
        error(err?.message);
        return;
      }
    }
  };


    if (name === "Examination Guide") {
      const validationError = validateFileName(fileName,"FileName");
      const authorValidationError = validateFileName(authorNameValue,"AuthorName");
      if(validationError || authorValidationError){
        if(validationError){
          setFileNameError(validationError);
        }
        if(authorValidationError){
          setAuthorNameError(authorValidationError);
        }
        return;
      }
    };

    if (type !== "profile") {
      const validationError = validateFileName(fileName,"FileName");
      if (validationError) {
        setFileNameError(validationError);
        return;
      }
    };

    //To check unique name of file
    if (name === "ImageMaterial" || (name === 'PodcastMaterial')) {
      const { data,error:SubjectNotFoundError } = await getAllImagePodcastMaterial({
        variables: {
          lId: selectedLibraryId,
          sjId: selectedSubjectId,
          cId: selectedClassId,
          limit: null,
          offset: null,
          searchInput: fileName.trim(),
        }
      });

      if (data?.getMylibraryImagesPodcastsInfo?.totalCount > 0) {
        error("File with this name already exists!");
        return;
      }
      if(SubjectNotFoundError?.message === "Subject not found for teacher"){
        handleClose();
        if(setIsUploadOpen){
          setIsUploadOpen(false);
        }
        return;
      }
    } else if (name === "Materials" || name === "Questions bank" || name === "Examination Guide") {
      const { data, error: SubjectNotFoundError} = await getAllTeachingMaterial({
        variables: {
          lId: selectedLibraryId,
          sjId: selectedSubjectId,
          type: name,
          cId: selectedClassId,
          limit: null,
          offset: null,
          searchInput: fileName.trim(),
          orderByColumn: null,
          orderByDirection: null
        }
      });

      if (data?.getMaterialsFromEbookType?.totalCount > 0) {
        error("File with this name already exists!");
        return;
      }
      if(SubjectNotFoundError?.message === "Subject not found for teacher"){
        handleClose();
        if(setIsUploadOpen){
          setIsUploadOpen(false);
        }
        return;
      }
    }else if(name === "Syndicated Videos"){
      const { data,error:SubjectNotFoundError } = await  getAllSyndicatedVideos({
        variables: {
            input:{
                cId: selectedClassId,
                lId: selectedLibraryId,
                sjId: selectedSubjectId,
                searchInput: fileName.trim(),
                category: [
                {
                    categoryId: "",
                    limit: null,
                    offset: null
                }
                ]
        }
    }
    });

      if (data?.getSyndicatedVideos?.length > 0) {
        error("File with this name already exists!");
        return;
      }
      if(SubjectNotFoundError?.message === "Subject not found for teacher"){
        handleClose();
        if(setIsUploadOpen){
          setIsUploadOpen(false);
        }
        return;
      }
    } 
    // else if (name === "Assignment") {
    //   if (role === TEACHER_ROLE) {
    //     const { data, error: SubjectNotFoundError } = await checkUniqueNameInAssignment({
    //       variables: {
    //         input: {
    //           cId: selectedClassId,
    //           sjId: selectedSubjectId,
    //           searchInput: fileName.trim(),
    //           limit: null,
    //           offset: null
    //         }
    //       }
    //     });
    //     if (data?.getAllUploadedAssignments?.totalCount > 0) {
    //       error("File with this name already exists!");
    //       return;
    //     }
    //     if (SubjectNotFoundError?.message === "Subject not found for teacher") {
    //       handleClose();
    //       if (setIsUploadOpen) {
    //         setIsUploadOpen(false);
    //       }
    //       return;
    //     }
    //   } else if (role === STUDENT_ROLE) {
    //     const { data, error: SubjectNotFoundError } = await checkUniqueNameInSubmitAssignment({
    //       variables: {
    //         input: {
    //           cId: selectedClassId,
    //           sjId: selectedSubjectId,
    //           searchInput: fileName.trim(),
    //           limit: null,
    //           offset: null
    //         }
    //       }
    //     });
    //     if (data?.getSubmittedAssignments?.totalCount > 0) {
    //       error("File with this name already exists!");
    //       return;
    //     }
    //     if (SubjectNotFoundError?.message === "Subject not found for teacher") {
    //       handleClose();
    //       if (setIsUploadOpen) {
    //         setIsUploadOpen(false);
    //       }
    //       return;
    //     }
    //   }
    // }
    else if(name === 'workshopVideo'){
      const {data} = await checkUniqueNameExistInWorkshop({
        variables: {
          searchInput: `%${fileName.trim()}%`
        }
      });
      if(data?.allWorkshopSessions?.nodes?.length > 0){
        error("File with this name already exists!");
        return;
      }
    }

    if(setPodcastDescription){
      setPodcastDescription(descriptionValue);
    }
    if(setWorkshopDescription){
      setWorkshopDescription(descriptionValue);
    }

    if(setuploaded){
      setuploaded(true);
    }
    handleClose();
    if(coverFileName && coverImageFile){
      await handleUploadCoverImage();
    };
    try {                                                                                                                                                                                 
      // const newFileName = `${folderName}/${moment().unix()}-${file?.name}`;
      // Replace spaces with underscores in fileName
      const sanitizedFileName = fileName.replace(/ /g, '_');

      // Extract the base name and extension from file.name
      const lastDotIndex = file.name.lastIndexOf('.');
      const extension = lastDotIndex !== -1 ? file.name.slice(lastDotIndex) : '';

      // Construct the new file name
      const newFileName = `${VIRTUAL_S3_PATH}${folderName}/${sanitizedFileName}-${moment().unix()}${extension}`;
      const { data } = await getPreSignedUrl({
        variables: {
          input: {
            key: newFileName
          }
        }
      });
      const { preSignedUrl } = data.getUploadPresignedUrl;
      await axios.put(preSignedUrl, file, {
        headers: {
          "Content-Type": file.type
        },
        onUploadProgress: (progressEvent: any) => {
          if (progressEvent && progressEvent.loaded && progressEvent.total) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            if(setUploadProgress){
              if(percentCompleted === 100){
                setUploadProgress(99);
              }else{
               setUploadProgress(percentCompleted);
              }
            }
          } else {
            console.log('Invalid progress event:', progressEvent);
          }
        }
      }).then((data) => {
        // if(setUploadProgress){
        // Set progress to 100% after upload is complete
        // setUploadProgress(99);
        // }
      });

      const fileUrl = preSignedUrl.split('?')[0];
      const url = fileUrl.split(`https://${bucketname}.s3.${region}.amazonaws.com/`)[1];
      setUrl(url);
      if (setFileData) {
        setFileData(file);
      }
      if (setFilename) {
        setFilename(fileName);
      }
      if(setGuideAuthorName){
        setGuideAuthorName(authorNameValue);
      }
      if(setVideoCategoryData){
        setVideoCategoryData(videoCategoryValue);
      }
      if (type === "profile" && setuploaded) {
        setuploaded(false);
      }
    } catch (err) {
      if(setuploaded){
        setuploaded(true);
      }
      if(setUploadFailed){
         setUploadFailed(true);
      }
      if(setUploadProgress){
        setUploadProgress(0);
      }
      // error("Failed to upload the file");
    }
    if(setIsUploadOpen){
       setIsUploadOpen(false);
    }
  };

  // close the upload popup
  const handleClose = () => {
    setOpen(false);
    setFile(null);
    setFilePreview("");
    setFileName("");
    setDescriptionValue("");
    setAuthorNameValue("");
    setHasSubmitted(false);
    setFileNameError(null);
    setDescriptionError(null);
    setCoverFileName("");
    setCoverImageFile(null);
    setAuthorNameError(null);
    setVideoCategoryError('');
    setInputValue('');
    setVideoCategoryValue(null);
    setCategories([]);
  };
  
  // set the text to display in upload popup according to the file type
  const handleDisplayText = (text: any) => {
    if (text === "image" || text === "profile") {
      return "Image";
    } else if (text === "video") {
      return "video";
    } else if (text === "all") {
      return "image, video or any file";
    } else if (text === "pdf") {
      return "PDF file";
    } else if (text === "assignment") {
      return "PDF/Word doc/excel/PPT";
    }else if (text === "teachingMaterials") {
      return "PDF/Word doc/excel/PPT/EPUB";
    } else if (text === "questionsBank") {
      return "CSV file";
    }
  };

  //To validate file name
  const validateFileName = (value: string, field: string) => {
    if (!value || value === "") {
      return field === "AuthorName" ? "Author Name is required":"File title is required";
    }
    if (!patterns.quizNameLengthRegex.test(value) && type === "assignment") {
      return messages.quizNameLength;
    }
    if (!patterns.fileNameLengthRegex.test(value)) {
      return field === "AuthorName" ? messages.authorNameLength : messages.fileNameLength;
    }
    if (!patterns.fileNameRegex.test(value)) {
      return field === "AuthorName" ? messages.authorName : messages.fileName;
    }
    if (patterns.consecutiveSpecialCharsRegex.test(value)) {
      return field === "AuthorName" ? messages.authorNameConsecutiveSpecialChars : messages.consecutiveSpecialChars;
    }
    if (!patterns.filenameAtleast1Alpha.test(value)) {
      return field === "AuthorName" ? messages.authorNameAtlease1Alpha : messages.filenameAtlease1Alpha;
    }
    return null;
  };

  //To validate description 
  const validateDescription = (value: string) => {
    if (!value || value === "") {
      return "Description is required";
    }
    if (!patterns.descriptionLengthRegex.test(value)) {
      return messages.descriptionLength;
    }
    return null;
  }

  //To validate video category 
  const validateVideoCategory = (value: string|null|undefined) => {
    if (!value || value === "") {
      return "Video category is required";
    }
    if (value.length < 1 || value.length > 100) {
      return 'Video category must be between 1 and 100 characters long'
    }else{
    if (!patterns.alphabetAndNumber.test(value)) {
      return messages.VideoCategory;
    }
    if (!patterns.NotStartWithNumber.test(value)) {
      return messages.VideoCategoryNotStartNumber;
    }}
    return null;
  }

  // Handle file name change and clear error
  const handleFileNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setFileName(value);
    if(setUploadFileName){
      setUploadFileName(value);
    }
    setFileNameError('');
    if(hasSubmitted){
      const validationError = validateFileName(value,"FileName");
      setFileNameError(validationError);
    }
  };

    // Handle author name change and clear error
    const handleAuthorNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      setAuthorNameValue(value);
      setAuthorNameError('');
      if(hasSubmitted){
        const validationError = validateFileName(value,"AuthorName");
        setAuthorNameError(validationError);
      }
    };  
    
  //To handle the description change and clear error
  const handleDescriptionChange  = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    setDescriptionValue(value);
    setDescriptionError('');
    if(hasSubmitted){
      const validationError: any = validateDescription(value.trim());
      setDescriptionError(validationError);
    }
  }

  //To remove the last value in input
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Backspace' && fileName?.length === 1) {
      setFileName('');
      if(setUploadFileName){
        setUploadFileName('');
      }
      setFileNameError("File title is required");
    }
  };

  // Add an event listener for the Enter key
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Enter"  && document.activeElement !== descriptionRef.current) {
        e.preventDefault(); // Prevent the default form submission
        handleSubmit();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [fileName, file, descriptionValue, authorNameValue,videoCategoryValue]); // Ensure the latest fileName and file are used

  return (
    <>
      {open && <Dialog
        open={open}
        PaperProps={{
          style: {
            borderRadius: "20px",
            width: getScreenDimensions()?.isMobileScreen ? "290px" : "580px",
            minHeight: type === 'profile' ? getScreenDimensions()?.isMobileScreen ? "220px" : "312px" : ((role === TEACHER_ROLE) && (type === 'audio')) ? "470px" : ((type === 'teachingMaterials') || (name === 'Examination Guide') || (name === 'Questions bank'))  ? 'auto' : '401px'
          },
        }}
      >
        <div className="uploadPopupMain">
          <div className="uploadPopup" style={{gap : ((type === 'audio') && !(descriptionError)) ? '10px' : ((name === "Examination Guide") && !(authorNameError)) ? 'none' : '25px'}}>
            <div className="paddiv">
              <div className="uploadContainer">
                <label className="iconGif" {...getRootProps({ onClick: (e) => e.stopPropagation() })} style={{ cursor: 'default' }}>
                  {!file && !filePreview ? (
                    <img className="cloud1Icon" src={cloudGif} alt="cloudGif"/>
                  ) : (
                    <Card
                      sx={{
                        ...(getScreenDimensions()?.isMobileScreen ? { height: "75px", padding: '0px' } : { padding: "10px", minHeight: "85px" }),
                        width: "100px",
                        margin: "5px"
                      }}
                    >
                      <CardCover>
                        {fileType === "video" ? (
                          <video autoPlay loop muted={fileType === "video"}  key={filePreview}>
                            <source src={filePreview} />
                          </video>
                        ) : (
                          <img className="previewImage" src={filePreview} alt="previewImage"/>
                        )}
                      </CardCover>
                    </Card>
                  )}
                </label>
                <div className={`contentCta ${(type === 'teachingMaterials') && 'learningMaterialUpload'}`}>
                  <label className="dragDropContainer" {...getRootProps({ onClick: (e) => e.stopPropagation() })} style={{ cursor: 'default' }}>
                    <span className="dragDropContainer1">
                      <span>{`Drag & drop `}</span>
                      <span className="videos">
                        {handleDisplayText(type)}
                      </span>
                      {/* {role === SCHOOL_ADMIN && <span>{` Cover Here`}</span>} */}
                    </span>
                  </label>
                  <label className="orBrowseFilesContainer">
                    <span>{`or `}</span>
                    <span className="browseFiles" {...getRootProps()}>
                      browse files
                    </span>
                    <span> on your computer</span>
                  </label>
                  <input data-testid="imageUpload" {...getInputProps()} />
                </div>
              </div>
              {(type !== 'profile') &&
              <div className="fieldsMainContainer" style={{minHeight: type === 'audio' ? '164px' : (name === "Examination Guide" || name === "Syndicated Videos") ? '157px' : ''}}>
                    <input
                      id="coverImage"
                      {...coverImageInputProps()}
                      style={{display: 'none'}}
                    />
                  <label 
                    className="coverImageContainer" 
                    {...coverImageRootProps({
                      onDrop: (e) => e.stopPropagation(),
                      onDrag: (e) => e.stopPropagation() 
                    })}
                    style={{
                      display: (type !== 'audio' && name !== "Examination Guide" && name!== "Syndicated Videos") ? 'none' : 'flex',
                      padding: ((type === 'audio' || name === "Examination Guide" || name === "Syndicated Videos") && (coverFileName)) ? 0 : '21px 22px'
                    }}
                  >
                    {
                      ((type === 'audio' || name === "Examination Guide" || name === "Syndicated Videos") && (coverFileName))
                    ?
                      <>
                        <img 
                            alt="coverImage"
                            src={coverImageFile ? URL.createObjectURL(coverImageFile) : ''}
                            className={(name === "Examination Guide" || name === "Syndicated Videos") ? "selectedGuideCoverImage" : "selectedCoverImage"}
                        />
                      </>
                    :
                      <>
                        <img src={CoverPlusImage} alt="plusIcon" className="plusStyle"/>
                        <div className="covertitle">Add cover</div>
                      </>
                    }
                    
                  </label>
                  <div 
                      className="inputFieldsContainer" 
                      style={{
                        width: type !== 'audio' ? '100%' : 'calc(100% - 158px)',
                        gap: (hasSubmitted && fileNameError) ? '12px' : (hasSubmitted && videoCategoryError) ?'30px':'9px'
                      }}
                  >
                    <div className="fileUploading" style={{ display: name !== 'Syndicated Videos' ? 'none' : 'flex' }}>
                      <div className="label">
                        <label className="fileTitle">Video Category</label>
                      </div>
                      <div className="inputContainer">
                        {/* <input
                            className="uploadedFile"
                            data-testid="uploadedFile"
                            placeholder="Grammar"
                            value={videoCategoryValue}
                            onChange={handleVideoCategoryChange}
                          /> */}
                        <Autocomplete
                          // freeSolo
                          options={categories.length > 0 ? categories : [{ label: 'No options', id: 'no-options' }]}
                          getOptionLabel={(option) => {
                            // Value selected with enter, right from the input
                            if (typeof option === 'string') {
                              return option;
                            }
                            // Add "xxx" option created dynamically
                            if (option.inputValue) {
                              return option.inputValue;
                            }
                            // Regular option
                            return option.label;
                          }}
                          loading={getCategoryLoading || addCategoryLoading}
                          sx={sxStyles}
                          componentsProps={{
                            popper: {
                              sx: {
                                "& .MuiAutocomplete-paper .MuiAutocomplete-listbox": {
                                  padding: 0,
                                  overflowX: "scroll",
                                },
                                "& .MuiAutocomplete-paper .MuiAutocomplete-listbox .MuiAutocomplete-option": {
                                  whiteSpace: "nowrap",
                                  minWidth: "fit-content",
                                }
                              },
                            },
                          }}
                          filterOptions={(options, params) => {
                            const filtered = filter(options, params);
                            setVideoCategoryError('');
                            const { inputValue } = params;
                            // Suggest the creation of a new value
                            const isExisting = options.some((option) => inputValue?.toLowerCase() === option?.label?.toLowerCase());
                            if (inputValue !== '' && !isExisting) {
                              filtered.push({
                                inputValue,
                                id:'add-new',
                                label: `Add "${inputValue}"`,
                              });
                            }
                    
                            return filtered;
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Video Category"
                              variant="outlined"
                              onChange={()=>{setVideoCategoryError('');}}
                              onInput={()=>{setVideoCategoryError('');}}
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {getCategoryLoading || addCategoryLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                ),
                              }}
                            />
                          )}
                          onInputChange={(event, value) => {
                            setInputValue(value);
                            if(setVideoCategoryData){
                            setVideoCategoryData(null);
                            }
                            const validationError = validateVideoCategory(value);

                            setVideoCategoryError(validationError);
                          }}
                          onChange={async (event, newValue) => {
                            setVideoCategoryError('');
                            setVideoCategoryValue(null);
                            if (typeof newValue === 'string') {
                              // const inputValue = newValue;
                              // const validationError = validateVideoCategory(inputValue);
                              // if (!validationError) {
                              //   const response = await addCategory({
                              //     variables: { category: inputValue?.trim(), sjId: selectedSubjectId }
                              //   });
                              //   const addedCategoryId = response.data.addSubjectCategory;
                              //   setVideoCategoryError('');
                              //   setVideoCategoryValue({ id: addedCategoryId, label: inputValue });
                              //   getCategory({ variables: { sjId: selectedSubjectId } });
                              // } else {
                              //   setVideoCategoryValue({ id: undefined, label: inputValue });
                              //   setVideoCategoryError(validationError);
                              // }
                            }else if (newValue?.inputValue) {
                              const inputValue = newValue?.inputValue;
                              const validationError = validateVideoCategory(inputValue);
                              if (!validationError) {
                                const response = await addCategory({
                                  variables: { category: inputValue?.trim(), sjId: selectedSubjectId }
                                });
                                const addedCategoryId = response.data.addSubjectCategory;
                                setVideoCategoryError('');
                                setVideoCategoryValue({ id: addedCategoryId, label: inputValue });
                                getCategory({ variables: { sjId: selectedSubjectId } });
                              } else {
                                setVideoCategoryValue({ id: undefined, label: inputValue });
                                setVideoCategoryError(validationError);
                              }
                            } else if (!newValue) {
                              setVideoCategoryError("Video category is required");
                            } else {
                              const validationError = validateVideoCategory(newValue.label);
                              if (validationError) {
                                setVideoCategoryError(validationError);
                              }
                              setVideoCategoryValue(newValue);
                            }
                          }}
                          value={videoCategoryValue}
                          renderOption={(props, option) => (
                            <li {...props} style={{ opacity: (categories.length < 1 && inputValue === "") ? 0.5 : 1 }}>
                              {typeof option === 'string' ? option : option.label}
                            </li>
                          )}
                          getOptionDisabled={(option) => {
                            // Disable options if there are no categories
                            if (categories.length < 1 && option?.id !== "add-new") {
                              return typeof option !== 'string'; // Disable non-string options
                            }
                            return false; // Enable all options when there are categories
                          }}                        
                          />
                        {hasSubmitted === true && videoCategoryError && <div className="errorMessage">{videoCategoryError}</div>}
                      </div>
                    </div>
                      <div 
                        className="fileUploading"
                      >
                        <div className="label">
                          <label className="fileTitle">File Title</label>
                        </div>
                        <div className="inputContainer">
                          <input
                            className="uploadedFile"
                            data-testid="uploadedFile"
                            placeholder={(type === "pdf"||type === "assignment" || type === "teachingMaterials") ? "example.pdf" : type === "image" ? "example.jpeg" : type === "audio" ? "example.mp3" : type === "questionsBank" ? "example.csv" : "example.mp4"}
                            type="text"
                            value={fileName}
                            onKeyDown={handleKeyDown}
                            onChange={handleFileNameChange}
                          />
                          {hasSubmitted === true && fileNameError && <div className="errorMessage">{fileNameError}</div>}
                        </div>
                      </div>
                      <div className="fileUploading" style={{display: descriptionAllowedTypes.includes(name ? name : '') ? 'flex' : 'none'}}>
                        <div className="label">
                          <label className="fileTitle">Description</label>
                        </div>
                        <div className="inputContainer">
                          <textarea
                            className="uploadedFileTextarea"
                            data-testid="uploadedFile-textarea"
                            placeholder={type === "pdf" ? "example.pdf" : type === "image" ? "example.jpeg" : (type === 'audio' || type === 'video') ? "Messages goes here..." : "Example.mp4"}
                            value={descriptionValue}
                            onChange={handleDescriptionChange}
                            ref={descriptionRef} // Add ref here
                          />
                          {hasSubmitted === true && descriptionError && <div className="errorMessage">{descriptionError}</div>}
                        </div>
                      </div>
                      <div className="fileUploading"style={{display: name !== 'Examination Guide' ? 'none' : 'flex'}}>
                        <div className="label">
                          <label className="fileTitle">Author Name</label>
                        </div>
                        <div className="inputContainer">
                          <input
                            className="uploadedFile"
                            data-testid="uploadedFile"
                            placeholder="Name"
                            value={authorNameValue}
                            onChange={handleAuthorNameChange}
                          />
                          {hasSubmitted === true && authorNameError && <div className="errorMessage">{authorNameError}</div>}
                        </div>
                      </div>
                  </div>
                 
              </div>
              }
            </div>
            <div className="ctaSet" onClick={handleSubmit}>
              <button className="uploadCta">
                <label className="upload">Upload</label>
              </button>
            </div>
            <button className="icCancel" data-testid="closeButton" onClick={()=>{
              handleClose();
              if(setIsUploadOpen){
                setIsUploadOpen(false);
              }
              }}>
              <img className="unionIcon" alt="closeIcon" src={closeIcon} />
            </button>
          </div>
        </div>
      </Dialog>}
    </>
  );
};

export default FileUpload;
